<template>
  <v-container fluid>
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "LayoutVacation",
};
</script>

<style scoped></style>
